import { POST_GOVBR_SERVICES } from '../constants/ActionTypes';

export function postServiceInfo(urls, subrequest) {
  const action = {
    type: POST_GOVBR_SERVICES,
    request: {
      op: 'get',
      path: '/@govbr-service-info',
      params: {
        urls: JSON.stringify(urls),
      },
    },
  };

  if (typeof subrequest === 'string' && subrequest.length > 0) {
    action.subrequest = subrequest;
  }

  return action;
}
